/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Color } from 'csstype'
import { Fragment } from 'react'
import { CidadaoListagemPessoaIdosaQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVacinasSection } from '../AcompanhamentoCondicaoSaudeVacinasSection'
import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection'
import { GRUPOS_IMUNOBILIOGICO_PESSOA_IDOSA } from '../model-acompanhamentoCondicaoSaudeAccordion'
import { AcompanhamentoCondicaoSaudeIvcfAccordionPanel } from './AcompanhamentoCondicaoSaudeIvcfAccordionPanel'
import { AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel } from './AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel'

interface AcompanhamentoCondicaoSaudePessoaIdosaAccordionSectionProps {
  row: CidadaoListagemPessoaIdosaQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudePessoaIdosaAccordionSection({
  row,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudePessoaIdosaAccordionSectionProps>) {
  const cidadaoConsolidado = row?.cidadao?.cidadaoConsolidado

  return (
    <Fragment>
      <AcompanhamentoCondicaoSaudeVacinasSection
        vacinas={cidadaoConsolidado.pessoaIdosa?.vacinasAplicadas}
        grupos={GRUPOS_IMUNOBILIOGICO_PESSOA_IDOSA}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeIvcfAccordionPanel
        riscoVulnerabilidade={row?.ivcf?.riscoVulnerabilidade}
        dataRegistro={row?.ivcf?.dataResultado}
        subgrupos={row?.ivcf?.subgrupo}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeMedicoesPessoaIdosaAccordionPanel
        quantidadeMedicoesPesoAlturaSimultaneos={
          cidadaoConsolidado.pessoaIdosa?.quantidadeMedicoesSimultaneasPesoAltura
        }
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionSection
        dataUltimasVisitasDomiciliares={
          cidadaoConsolidado.pessoaIdosa?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
        }
        qtdVisitasDomiciliares={cidadaoConsolidado.pessoaIdosa?.visitaDomiciliar?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </Fragment>
  )
}
